import { useParams } from "react-router-dom";

/**
 * @returns {import("@seabrookstudios/pitch2table-core").RoyaltyCategories|undefined}
 */
export const useCategoryFromRoute = () => {
  return (
    /** @type {import("@seabrookstudios/pitch2table-core").RoyaltyCategories} */ (useParams().category) || undefined
  );
};

/**
 * @returns {string|undefined}
 */
export const useYearFromParam = () => {
  return useParams().year;
};

/**
 * @returns {import("@seabrookstudios/pitch2table-core").RoyaltyType|undefined}
 */
export const useTypeFromParam = () => {
  return /** @type {import("@seabrookstudios/pitch2table-core").RoyaltyType} */ (useParams().type) || undefined;
};

/**
 * @returns {import("@seabrookstudios/pitch2table-core").RoyaltyReminderId|undefined}
 */
export const useRoyaltyReminderIdFromRoute = () => {
  return (
    /** @type {import("@seabrookstudios/pitch2table-core").RoyaltyReminderId} */ (useParams().reminderId) || undefined
  );
};
